import { factory, sequence } from 'stahlwerk';

export const createGeofence = factory({
  crewId: sequence(),
  groupId: sequence(),
});
